export default "__VITE_ASSET__CT8ZwNvF__"